import { useParams } from "react-router";
import { DocumentationCard } from "@/services/backend/vbs/work-orders/components/documentation-card";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function WorkOrderCompletionDocumentationRoute() {
  const { workOrderId, documentationId } = useParams();
  const { data: workOrder } = useVbsWorkOrderShowQuery({ id: workOrderId! });
  return (
    <DocumentationCard
      documentationId={documentationId!}
      workOrderId={workOrderId!}
      disabled={workOrder !== undefined && isImmutable(workOrder)}
    />
  );
}
